import { serviceRoles } from "config/access";
import { RENTAL_HOUSE } from "constants/routes";
import { checkAccess } from "helpers/auth";
import Page from "./container/RentalHousePage";

export default function getSettingsRoute(userAuth) {
  const { predilux, account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [predilux.name]: [predilux.roles.superadmin, predilux.roles.developer],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: RENTAL_HOUSE,
    withSidebar: true,
    withAppBar: true,
    component: Page,
  };
}
